import { render, staticRenderFns } from "./ClientForm.vue?vue&type=template&id=5c266674&scoped=true"
import script from "./ClientForm.vue?vue&type=script&lang=ts"
export * from "./ClientForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c266674",
  null
  
)

export default component.exports